import React, { Fragment, useState } from 'react';
import classNames from 'classnames';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

// import styles from './SlideDown.module.scss';

const SlideDown = ({ text, title }) => {
	const [clicked, setClicked] = useState(false);

	const ArrowClassDown = classNames({
		'my-2': true,
		hidden: clicked,
	});

	const ArrowClassUp = classNames({
		'my-2': true,
		hidden: !clicked,
	});

	const PClassText = classNames({
		'text-white text-sm text-center px-4 py-2': true,
		hidden: !clicked,
	});

	const clickedElement = op => {
		console.log(op);
		setClicked(op);
	};

	return (
		<Fragment>
			<div className='flex flex-col justify-center items-center h-16'>
				<p className='text-tcn-dark-blue font-Avenir-Black text-xl text-center'>{title}</p>
			</div>
			<div
				className='flex flex-col items-center justify-center bg-tcn-red w-full h-auto'
				onClick={() => clickedElement(clicked == true ? false : true)}
			>
				<FaChevronDown className={ArrowClassDown} />
				<FaChevronUp className={ArrowClassUp} />
				<p className={PClassText}>{text}</p>
			</div>
		</Fragment>
	);
};

export default SlideDown;
